import type { ColumnDef } from '@tanstack/react-table';
import type { GetMicrostoreColumnsPaginatedQuery } from 'data/__generated__';

import { textColumn } from 'components/DataTable';

export type TemplateColumnRow =
    GetMicrostoreColumnsPaginatedQuery['microstoreColumnsFilter']['microstoreColumns'][number];

export const templateColumnsListColumns: ColumnDef<TemplateColumnRow, unknown>[] = [
    textColumn<TemplateColumnRow, Record<string, never>>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<TemplateColumnRow, Record<string, never>>({
        accessorKey: 'siteName',
        header: 'Site',
        defaultVisible: true,
    }),
];
